// @ts-nocheck
import {
    AccountTermsModel,
    getCurrentAccountTerms,
    GetUserAccountTermsApiParameter,
} from "@store/Framework/Services/AccountService";
import { getAccountTermsForCustomer } from "@store/Framework/Store/Store/Data/Accounts/AccountSelectors";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, GetUserAccountTermsApiParameter, AccountTermsModel>;

export const DispatchBeginAccountTerms: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Accounts/BeginLoadAccount",
    });
};

export const GetAccountTerms: HandlerType = async props => {
    const state = props.getState();
    const { currentTermsUrl, nextTermsUrl } = getAccountTermsForCustomer(state);
    if (currentTermsUrl && nextTermsUrl) {
        props.apiResult = { currentTermsUrl, nextTermsUrl };
        return;
    }

    try {
        props.apiResult = await getCurrentAccountTerms(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 403) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadAccountTerms: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Accounts/CompleteLoadAccountTerms",
        model: props.apiResult,
        currentAccountId: props.getState().context.session.billToId || "",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginAccountTerms,
    GetAccountTerms,
    DispatchCompleteLoadAccountTerms,
    ExecuteOnSuccessCallback,
];

const loadCurrentAccountTerms = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadCurrentAccountTerms");
export default loadCurrentAccountTerms;
